var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal-instagram",on:{"click":function($event){return _vm.hide()}}},[(_vm.show)?_c('iframe',{attrs:{"src":`/suarapenentu/iframe?reel_id=${_vm.reel_id}`}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }